import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { auctionPropertiesType } from '../../types';
import { ALL_BIDS } from '../../graphql/bids';
import './_styles_/BidsPopup.css';
import Spinner from '../Spinner';
import ModalDialog from '../ModalDialog';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import { ON_AUCTION_CHANGED } from '../../graphql/auctions';
import Error from '../errors/Error';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import BidsPopup from './BidsPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

BidsPopupLoader.propTypes = {
    onCancelHandler: PropTypes.func.isRequired,
    auctionId: PropTypes.number.isRequired,
    auctionProps: auctionPropertiesType.isRequired,
};

function BidsPopupLoader(props) { // NOSONAR javascript:S3776
    const {
        onCancelHandler,
        auctionId,
        auctionProps,
    } = props;
    const { t } = useTranslation();
    const variables = useMemo(() => ({
        auctionId: auctionId,
    }), [auctionId]);
    const {
        loading,
        error,
        data,
        refetch,
    } = useExtendedQuery(ALL_BIDS, {
        variables,
        variablesToUrl: false,
    });

    useExtendedSubscription(ON_AUCTION_CHANGED, {
        refetch,
        refetchVariables: { auctionId: auctionId },
        dataProperty: 'auctionChanged',
    });

    let content;
    const closeButton =
        <button type="button" className="close-button button-small button-primary-text auction-bids--header--close" onClick={onCancelHandler}>
            <span aria-label={t('auctions.bids-list.dismiss')} role="img"><FontAwesomeIcon icon="times" /></span>
        </button>;

    if (loading) {
        content = (
            <div className={'auction-bids'}>
                {closeButton}
                <Spinner className="bids-popup-loading" />
            </div>
        );
    } else if (error) {
        content = (
            <div className={'auction-bids'}>
                {closeButton}
                <Error className="bids-error" error={error} />
            </div>
        );
    } else {
        content = <BidsPopup
            auction={data.allBids.auctionDetail}
            bids={data.allBids.bidList.models}
            auctionMembers={data.allBids.auctionMembers.models}
            auctionProps={auctionProps}
            onCancelHandler={onCancelHandler}
            popupRefetch={refetch}
        />;
    }

    return (
        <ModalDialog onCancel={onCancelHandler}>
            {content}
        </ModalDialog>
    );
}

export default BidsPopupLoader;
